// components/PetSitterCardSkeleton.tsx
import React from 'react'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

import { StyledInlineCard, StyledInlineCardContent } from './PetSitterCard'

const PetSitterCardSkeleton: React.FC = () => {
  return (
    <StyledInlineCard>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <Box
          className="EmtInlineCard-image-wrapper"
          sx={{
            position: 'relative',
            width: '172px',
            height: '172px',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '12px' }} />
        </Box>
        <StyledInlineCardContent
          sx={{
            flexGrow: 1,
            padding: '0px !important',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            overflow: 'hidden',
          }}
        >
          <Skeleton variant="text" width="60%" height={24} sx={{ borderRadius: '4px' }} />
          <Skeleton variant="text" width="40%" height={20} sx={{ borderRadius: '4px' }} />
          <Skeleton variant="text" width="80%" height={15} sx={{ borderRadius: '4px' }} />
          <Skeleton variant="rectangular" width="100%" height={36} sx={{ borderRadius: '18px' }} />
        </StyledInlineCardContent>
      </Box>
    </StyledInlineCard>
  )
}

export default PetSitterCardSkeleton
